import { Component, Input } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';
import { confirm } from 'devextreme/ui/dialog';

@Component({
    selector: 'app-reset-grid-state',
    templateUrl: './reset-grid-state.component.html',
    styleUrls: ['./reset-grid-state.component.scss'],
    standalone: false
})
export class ResetGridStateComponent {
  @Input() dataGrid: DxDataGridComponent;
  @Input() stylingMode: "text" | "outlined" | "contained" = "text";

  onStateResetClick() {
    if (this.dataGrid == null) return;
    let result = confirm("Réinitialiser l'affichage par défaut ? ?", "Confirmation");
    result.then((confirmed) => {
      if (confirmed) {
        this.dataGrid.instance.state(null);
      }
    });
  }
}
